import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Event$, EventAttendee, User_$reflection, EventAttendee_$reflection, Task_$reflection, Event$_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, int32_type, record_type, array_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { compare, utcNow } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { map as map_1, append, equalsWith } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { int32ToString, createObj, defaultOf, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { defaultArg, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Course, Task, toastServerError, Event$ as Event$_1 } from "../ApiClient.jsx";
import { successToast, errorToast } from "../Toasts.jsx";
import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { SkeletonItem, Skeleton, Avatar, Checkbox, Tooltip, Caption1, PopoverSurface, PopoverTrigger, Popover, Persona, Body1, Subtitle2, CardHeader, Link, Button, Caption2, Badge, Label, tokens, Text as Text$, Title3, Image, CardPreview, Card } from "@fluentui/react-components";
import { tryHead, take, length, empty, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { CheckmarkCircleRegular, CheckmarkLockRegular, QuestionRegular, TextQuoteRegular, PersonArrowRightRegular, DismissRegular, LockClosedRegular, EditRegular, LocationRegular, ClipboardTaskListLtrRegular, PeopleQueueRegular, ClockRegular, CalendarDateRegular } from "@fluentui/react-icons";
import { nb } from "date-fns/locale";
import { format as format_2 } from "date-fns";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { notFoundView } from "../Helpers.jsx";

class Model extends Record {
    constructor(Event$, IsFetchingEventDetails, UserCompletedTasks, Attendees, UserIsEligible, UserIsAttending) {
        super();
        this.Event = Event$;
        this.IsFetchingEventDetails = IsFetchingEventDetails;
        this.UserCompletedTasks = UserCompletedTasks;
        this.Attendees = Attendees;
        this.UserIsEligible = UserIsEligible;
        this.UserIsAttending = UserIsAttending;
    }
}

function Model_$reflection() {
    return record_type("Event.EventView.Model", [], Model, () => [["Event", option_type(Event$_$reflection())], ["IsFetchingEventDetails", bool_type], ["UserCompletedTasks", array_type(Task_$reflection())], ["Attendees", array_type(EventAttendee_$reflection())], ["UserIsEligible", bool_type], ["UserIsAttending", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEvent", "SetIsFetching", "UpdateUserCompletedTasks", "UpdateAttendees", "UpdateUserIsEligible", "UpdateUserIsAttending", "SignedUp", "Withdrew", "CompleteTask", "RevokeTask"];
    }
}

function Msg_$reflection() {
    return union_type("Event.EventView.Msg", [], Msg, () => [[["Item", option_type(Event$_$reflection())]], [["Item", bool_type]], [["Item", array_type(Task_$reflection())]], [["Item", array_type(EventAttendee_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item", User_$reflection()]], [["Item", User_$reflection()]], [["Item", Task_$reflection()]], [["Item", int32_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Event, msg.fields[0], model.UserCompletedTasks, model.Attendees, model.UserIsEligible, model.UserIsAttending);
        case 2:
            return new Model(model.Event, model.IsFetchingEventDetails, msg.fields[0], model.Attendees, model.UserIsEligible, model.UserIsAttending);
        case 3:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, msg.fields[0], model.UserIsEligible, model.UserIsAttending);
        case 4:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, model.Attendees, msg.fields[0], model.UserIsAttending);
        case 5:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, model.Attendees, model.UserIsEligible, msg.fields[0]);
        case 6: {
            const newAttendee = new EventAttendee(msg.fields[0], model.UserCompletedTasks, utcNow());
            const matchValue = model.Attendees;
            if (!equalsWith(equals, matchValue, defaultOf()) && (matchValue.length === 0)) {
                return new Model(map((event_1) => (new Event$(event_1.Id, event_1.Name, event_1.Enabled, event_1.Summary, event_1.Description, event_1.Address, event_1.MaxAttendees, event_1.AttendeeCount + 1, event_1.Time, event_1.Course, event_1.Teacher, event_1.Region)), model.Event), model.IsFetchingEventDetails, model.UserCompletedTasks, model.Attendees, model.UserIsEligible, true);
            }
            else {
                return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, append([newAttendee], matchValue), model.UserIsEligible, true);
            }
        }
        case 7: {
            const matchValue_1 = model.Attendees;
            if (!equalsWith(equals, matchValue_1, defaultOf()) && (matchValue_1.length === 0)) {
                return new Model(map((event_2) => (new Event$(event_2.Id, event_2.Name, event_2.Enabled, event_2.Summary, event_2.Description, event_2.Address, event_2.MaxAttendees, event_2.AttendeeCount - 1, event_2.Time, event_2.Course, event_2.Teacher, event_2.Region)), model.Event), model.IsFetchingEventDetails, model.UserCompletedTasks, model.Attendees, model.UserIsEligible, false);
            }
            else {
                return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks, matchValue_1.filter((a) => (a.User.Id !== msg.fields[0].Id)), model.UserIsEligible, false);
            }
        }
        case 8:
            return new Model(model.Event, model.IsFetchingEventDetails, append([msg.fields[0]], model.UserCompletedTasks), model.Attendees, model.UserIsEligible, model.UserIsAttending);
        case 9:
            return new Model(model.Event, model.IsFetchingEventDetails, model.UserCompletedTasks.filter((task_1) => (task_1.Id !== msg.fields[0])), model.Attendees, model.UserIsEligible, model.UserIsAttending);
        default:
            return new Model(msg.fields[0], model.IsFetchingEventDetails, model.UserCompletedTasks, model.Attendees, model.UserIsEligible, model.UserIsAttending);
    }
}

function init() {
    return new Model(undefined, true, [], [], false, false);
}

function Promises_fetchEvent(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Get(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            dispatch(new Msg(1, [false]));
        }
        else {
            dispatch(new Msg(0, [res.fields[0]]));
        }
        return res;
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_fetchAttendees(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.GetAttendees(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(3, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_checkIsAttending(eventId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.CheckOwnAttendance(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(5, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_fetchUserCompletedTasks(dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Task.GetMy());
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(2, [res.fields[0]]));
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_checkIsEligible(courseId, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Course.CheckOwnEligibility(courseId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(4, [res.fields[0]]));
        }
        dispatch(new Msg(1, [false]));
    }));
    void (pr_1.catch((arg) => {
        const _arg = toastServerError(setCtx, arg);
        dispatch(new Msg(1, [false]));
    }));
}

function Promises_signUp(eventId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.SignUp(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, "signUpError", "Kunne ikke melde på", "Kunne ikke finne kurs å melde på", undefined);
        }
        else {
            dispatch(new Msg(6, [self]));
            successToast(setCtx, "signUpEventSuccess", "Påmeldt", "Du ble meldt på kurset");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_withdraw(eventId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Withdraw(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 2: {
                    dispatch(new Msg(5, [false]));
                    break;
                }
                case 1: {
                    errorToast(setCtx, "withdrawUserNotFound", "Kunne ikke melde av", "Noe gikk galt", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "withdrawEventNotFound", "Kunne ikke melde av", "Kunne ikke finne kurs å melde av", undefined);
            }
        }
        else {
            dispatch(new Msg(7, [self]));
            successToast(setCtx, "withdrawEventSuccess", "Avmeldt", "Du ble meldt av kurset");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_completeTask(taskId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Task.CompleteCourseTask(taskId, new Int32Array([self.Id])));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, `completeTask${taskId}Error`, "Kunne ikke sette oppgave som fullført", "Noe gikk galt", undefined);
        }
        else {
            dispatch(new Msg(8, [res.fields[0]]));
            successToast(setCtx, `completeTask${taskId}Success`, "Oppgave fullført", "Oppgaven ble satt som fullført");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_revokeTask(taskId, self, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Task.RevokeCourseTask(taskId, new Int32Array([self.Id])));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, `revokeTask${taskId}Error`, "Kunne ikke sette oppgave som ikke fullført", "Noe gikk galt", undefined);
        }
        else {
            dispatch(new Msg(9, [taskId]));
            successToast(setCtx, `revokeTask${taskId}Success`, "Oppgave satt som ikke fullført", "Oppgaven ble satt som ikke fullført");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function HeaderCard(headerCardInputProps) {
    let elems_15, el_2, el, elems_14, elems_7, elems, el_4, el_6, elems_6, elems_1, el_8, el_10, locale, formatOptions, elems_2, el_12, el_14, locale_1, formatOptions_1, elems_3, el_16, el_18, elems_4, el_20, el_22, elems_5, elems_13;
    const dispatch = headerCardInputProps.dispatch;
    const model = headerCardInputProps.model;
    const event = headerCardInputProps.event;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const eventIsFull = event.AttendeeCount >= event.MaxAttendees;
    const el_78 = Card;
    return createElement(el_78, createObj(ofArray([["style", {
        minHeight: 35 + "vh",
        display: "flex",
        padding: 0,
    }], (elems_15 = [(el_2 = CardPreview, createElement(el_2, {
        children: (el = Image, createElement(el, {
            style: {
                height: 15 + "vh",
            },
            fit: "cover",
            src: "https://4kwallpapers.com/images/walls/thumbs_3t/5841.jpg",
        })),
    })), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexGrow", 1]), delay(() => append_1(singleton(["flexWrap", "wrap"]), delay(() => append_1(singleton(["justifyContent", "space-between"]), delay(() => append_1(singleton(["padding", 15]), delay(() => append_1(singleton(["gap", 15 + "px "]), delay(() => {
        const matchValue = screenSize;
        switch (matchValue.tag) {
            case 0:
            case 1:
                return singleton(["justifyContent", "center"]);
            default: {
                return empty();
            }
        }
    })))))))))))))))], (elems_14 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => {
        let matchValue_1;
        return append_1((matchValue_1 = screenSize, (matchValue_1.tag === 0) ? (empty()) : ((matchValue_1.tag === 1) ? (empty()) : singleton(["maxWidth", 60 + "%"]))), delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["gap", 20 + "px "]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["justifyContent", "space-between"])))))))));
    })))], (elems_7 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems = [(el_4 = Title3, createElement(el_4, {
        children: event.Name,
    })), (el_6 = Text$, createElement(el_6, {
        children: event.Summary,
        style: {
            color: tokens.colorNeutralForeground3,
        },
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 20 + "px ",
        flexWrap: "wrap",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_1 = [(el_8 = CalendarDateRegular, createElement(el_8, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_10 = Label, createElement(el_10, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_2(event.Time, "dd MMMM yyyy", formatOptions))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_2 = [(el_12 = ClockRegular, createElement(el_12, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_14 = Label, createElement(el_14, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale_1 = nb, (formatOptions_1 = {}, (formatOptions_1.locale = locale_1, format_2(event.Time, "HH:mm", formatOptions_1))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_3 = [(el_16 = PeopleQueueRegular, createElement(el_16, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_18 = Label, createElement(el_18, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${event.AttendeeCount}/${event.MaxAttendees}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_4 = [(el_20 = ClipboardTaskListLtrRegular, createElement(el_20, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_22 = Label, createElement(el_22, createObj(toList(delay(() => append_1(singleton(["size", "medium"]), delay(() => append_1(singleton(["style", {
        color: tokens.colorNeutralForeground3,
    }]), delay(() => {
        let matchValue_2, event_1;
        return singleton(["children", `${(matchValue_2 = model.Event, (matchValue_2 != null) ? ((event_1 = matchValue_2, event_1.Course.Tasks.length)) : 0)}`]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_5 = toList(delay(() => {
        let el_24;
        return append_1(singleton((el_24 = LocationRegular, createElement(el_24, {
            fontSize: 24,
            primaryFill: tokens.colorBrandBackground,
        }))), delay(() => {
            let el_26;
            return append_1(singleton((el_26 = Label, createElement(el_26, {
                size: "medium",
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: event.Address,
            }))), delay(() => {
                let el_30, el_28;
                return (ctx.User.IsAdmin && !event.Enabled) ? singleton((el_30 = Badge, createElement(el_30, {
                    style: {
                        marginLeft: 10,
                    },
                    appearance: "tint",
                    color: "warning",
                    size: "large",
                    children: (el_28 = Caption2, createElement(el_28, {
                        children: "Utkast",
                    })),
                }))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => append_1(singleton(["justifyContent", "flex-start"]), delay(() => {
        let matchValue_3;
        return append_1((matchValue_3 = screenSize, (matchValue_3.tag === 0) ? singleton(["flexGrow", 1]) : ((matchValue_3.tag === 1) ? singleton(["flexGrow", 1]) : (empty()))), delay(() => append_1(singleton(["gap", 10 + "px "]), delay(() => singleton(["minHeight", 100 + "%"])))));
    })))))))))], (elems_13 = toList(delay(() => {
        let el_34, el_32, el_50, elems_9, el_46, el_42, el_44, el_48, el_60, elems_10, el_56, el_52, el_54, el_58;
        return append_1((ctx.User.IsAdmin ? true : (ctx.User.Id === event.Teacher.Id)) ? append_1(singleton((el_34 = Button, createElement(el_34, {
            icon: (el_32 = EditRegular, createElement(el_32, {})),
            children: "Rediger",
            appearance: "primary",
        }))), delay(() => {
            let el_40, elems_8, el_38, el_36;
            return singleton((el_40 = Link, createElement(el_40, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurs", int32ToString(event.Id), "deltakerliste"]), 1)], (elems_8 = [(el_38 = Button, createElement(el_38, {
                style: {
                    width: 100 + "%",
                },
                icon: (el_36 = ClipboardTaskListLtrRegular, createElement(el_36, {})),
                children: "Deltakerliste",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])])))));
        })) : append_1(!model.UserIsEligible ? singleton((el_50 = Card, createElement(el_50, createObj(ofArray([["appearance", "outline"], ["style", createObj(toList(delay(() => append_1(singleton(["maxWidth", 250]), delay(() => {
            const matchValue_4 = screenSize;
            switch (matchValue_4.tag) {
                case 0:
                case 1:
                    return singleton(["minWidth", 100 + "%"]);
                default: {
                    return empty();
                }
            }
        })))))], (elems_9 = [(el_46 = CardHeader, createElement(el_46, {
            image: (el_42 = LockClosedRegular, createElement(el_42, {
                fontSize: 28,
            })),
            header: (el_44 = Subtitle2, createElement(el_44, {
                children: "Ikke tilgjengelig",
            })),
        })), (el_48 = Body1, createElement(el_48, {
            children: "Dette kurset er på et nivå du ikke har tilgang til enda.",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])]))))) : ((compare(event.Time, utcNow()) <= 0) ? singleton((el_60 = Card, createElement(el_60, createObj(ofArray([["appearance", "outline"], ["style", createObj(toList(delay(() => append_1(singleton(["maxWidth", 250]), delay(() => {
            const matchValue_5 = screenSize;
            switch (matchValue_5.tag) {
                case 0:
                case 1:
                    return singleton(["minWidth", 100 + "%"]);
                default: {
                    return empty();
                }
            }
        })))))], (elems_10 = [(el_56 = CardHeader, createElement(el_56, {
            image: (el_52 = ClockRegular, createElement(el_52, {
                fontSize: 28,
            })),
            header: (el_54 = Subtitle2, createElement(el_54, {
                children: model.UserIsAttending ? "Avmelding stengt" : "Påmelding stengt",
            })),
        })), (el_58 = Body1, createElement(el_58, {
            children: "Dette kurset er enten påbegynt eller ferdig.",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])]))))) : empty()), delay(() => {
            let el_64, el_62, el_68, el_66;
            return model.UserIsAttending ? singleton((el_64 = Button, createElement(el_64, {
                icon: (el_62 = DismissRegular, createElement(el_62, {})),
                appearance: "secondary",
                children: "Meld av",
                disabled: compare(event.Time, utcNow()) <= 0,
                onClick: (_arg) => {
                    Promises_withdraw(event.Id, ctx.User, dispatch, setCtx);
                },
            }))) : append_1(singleton((el_68 = Button, createElement(el_68, {
                icon: (el_66 = PersonArrowRightRegular, createElement(el_66, {})),
                disabled: (!model.UserIsEligible ? true : eventIsFull) ? true : (compare(event.Time, utcNow()) <= 0),
                appearance: "primary",
                children: "Meld på",
                onClick: (_arg_1) => {
                    Promises_signUp(event.Id, ctx.User, dispatch, setCtx);
                },
            }))), delay(() => {
                let el_70;
                return eventIsFull ? singleton((el_70 = Text$, createElement(el_70, {
                    children: "Kurset er fullt",
                }))) : empty();
            }));
        })), delay(() => append_1(singleton(createElement("div", {
            style: {
                flexGrow: 2,
            },
        })), delay(() => {
            let el_76, elems_12, el_74, elems_11, el_72;
            return singleton((el_76 = Link, createElement(el_76, createObj(ofArray([["style", createObj(toList(delay(() => ((screenSize.tag === 0) ? singleton(["alignSelf", "center"]) : ((screenSize.tag === 1) ? singleton(["alignSelf", "center"]) : singleton(["alignSelf", "end"]))))))], ["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(event.Teacher.Id)]), 1)], (elems_12 = [(el_74 = Button, createElement(el_74, createObj(ofArray([["size", "large"], ["appearance", "subtle"], (elems_11 = [(el_72 = Persona, createElement(el_72, {
                style: {
                    justifySelf: "flex-end",
                },
                name: `${event.Teacher.FirstName} ${event.Teacher.LastName}`,
                secondaryText: "Kursholder",
                size: "medium",
                avatar: {
                    color: "cranberry",
                    image: {
                        src: defaultArg(event.Teacher.ImageUrl, ""),
                    },
                },
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])))));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_15))])])));
}

function AboutEvent(description) {
    let elems, el_4, el, el_2, el_6;
    const el_8 = Card;
    return createElement(el_8, createObj(ofArray([["size", "large"], (elems = [(el_4 = CardHeader, createElement(el_4, {
        image: (el = TextQuoteRegular, createElement(el, {
            fontSize: 32,
        })),
        header: (el_2 = Subtitle2, createElement(el_2, {
            children: "Om kurset",
        })),
    })), (el_6 = Body1, createElement(el_6, {
        children: description,
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

function TaskList(taskListInputProps) {
    let elems_5;
    const dispatch = taskListInputProps.dispatch;
    const model = taskListInputProps.model;
    const event = taskListInputProps.event;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const isMobile = equals(useFeliz_React__React_useResponsive_Static_Z434A9929(), new ScreenSize(0, []));
    const el_44 = Card;
    return createElement(el_44, createObj(ofArray([["size", "large"], (elems_5 = toList(delay(() => {
        let el_18, el, el_2, el_16;
        return append_1(singleton((el_18 = CardHeader, createElement(el_18, {
            image: (el = ClipboardTaskListLtrRegular, createElement(el, {
                fontSize: 32,
            })),
            header: (el_2 = Subtitle2, createElement(el_2, {
                children: "Oppgaver",
            })),
            action: (el_16 = Popover, createElement(el_16, createObj(toList(delay(() => append_1(isMobile ? singleton(["positioning", "below-start"]) : singleton(["positioning", "before"]), delay(() => {
                let elems_1, el_8, el_6, el_4, el_14, elems, el_10, text_2, el_12, elemsToUse;
                return singleton((elems_1 = [(el_8 = PopoverTrigger, createElement(el_8, {
                    children: (el_6 = Button, createElement(el_6, {
                        icon: (el_4 = QuestionRegular, createElement(el_4, {})),
                        appearance: "subtle",
                    })),
                })), (el_14 = PopoverSurface, createElement(el_14, createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    maxWidth: isMobile ? (75 + "vw") : (400 + "px"),
                }], (elems = [(el_10 = Subtitle2, createElement(el_10, {
                    children: "Godkjenning av oppgaver",
                })), (text_2 = "Hvis kurset inneholder oppgaver du selv kan markere som fullført, vises en avkrysningsboks ved disse. For øvrige oppgaver er det kursholder som må godkjenne gjennomføringen. Oppgaver kan ikke markeres som gjennomført før kurset har begynt.", (el_12 = Caption1, createElement(el_12, {
                    children: text_2,
                })))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], (elemsToUse = ((length(elems_1) <= 2) ? elems_1 : take(2, elems_1)), ["children", reactApi_1.Children.toArray(elemsToUse)])));
            }))))))),
        }))), delay(() => map_1((task) => {
            const userHasCompleted = model.UserCompletedTasks.some((completedTask) => (completedTask.Id === task.Id));
            const el_42 = Card;
            return createElement(el_42, createObj(toList(delay(() => append_1(singleton(["appearance", "subtle"]), delay(() => append_1(!isMobile ? singleton(["orientation", "horizontal"]) : empty(), delay(() => append_1(singleton(["size", "small"]), delay(() => append_1(singleton(["id", `${task.Id}`]), delay(() => {
                let elems_4;
                return singleton((elems_4 = toList(delay(() => {
                    let el_38;
                    return append_1(singleton((el_38 = CardHeader, createElement(el_38, createObj(toList(delay(() => append_1(singleton(["image", (task.VerificationRequired ? ((props_27) => {
                        const el_20 = CheckmarkLockRegular;
                        return createElement(el_20, createObj(props_27));
                    }) : ((props_31) => {
                        const el_22 = CheckmarkCircleRegular;
                        return createElement(el_22, createObj(props_31));
                    }))(toList(delay(() => append_1(userHasCompleted ? singleton(["primaryFill", tokens.colorStatusSuccessForeground1]) : singleton(["primaryFill", tokens.colorNeutralForeground3]), delay(() => singleton(["fontSize", 24]))))))]), delay(() => {
                        let el_24;
                        return append_1(singleton(["header", (el_24 = Body1, createElement(el_24, {
                            strikethrough: userHasCompleted,
                            children: task.Name,
                        }))]), delay(() => {
                            let el_26;
                            return append_1(!isMobile ? singleton(["description", (el_26 = Caption1, createElement(el_26, {
                                strikethrough: userHasCompleted,
                                children: task.Description,
                            }))]) : empty(), delay(() => {
                                let el_31, matchValue_1, el_28, el_36, matchValue_2, el_33;
                                return model.UserIsAttending ? singleton(["action", !task.VerificationRequired ? ((el_31 = Tooltip, createElement(el_31, createObj(ofArray([["content", userHasCompleted ? "Marker som ikke fullført" : "Marker som fullført"], (matchValue_1 = tryHead([(el_28 = Checkbox, createElement(el_28, {
                                    checked: userHasCompleted,
                                    disabled: compare(event.Time, utcNow()) >= 0,
                                    onChange: (_arg, c) => {
                                        const _b = Checkbox_toBool(c);
                                        if (userHasCompleted) {
                                            Promises_revokeTask(task.Id, ctx.User, dispatch, setCtx);
                                        }
                                        else {
                                            Promises_completeTask(task.Id, ctx.User, dispatch, setCtx);
                                        }
                                    },
                                }))]), (matchValue_1 == null) ? ["children", defaultOf_1()] : ["children", matchValue_1])]))))) : ((el_36 = Tooltip, createElement(el_36, createObj(ofArray([["content", userHasCompleted ? (`Godkjent av ${event.Teacher.FirstName} ${event.Teacher.LastName}`) : (`Må godkjennes av ${event.Teacher.FirstName} ${event.Teacher.LastName}`)], (matchValue_2 = tryHead([(el_33 = Avatar, createElement(el_33, {
                                    style: {
                                        margin: 5,
                                    },
                                    size: 24,
                                    color: "cranberry",
                                    name: `${event.Teacher.FirstName} ${event.Teacher.LastName}`,
                                    image: {
                                        src: defaultArg(event.Teacher.ImageUrl, ""),
                                    },
                                }))]), (matchValue_2 == null) ? ["children", defaultOf_1()] : ["children", matchValue_2])])))))]) : empty();
                            }));
                        }));
                    })))))))), delay(() => {
                        let el_40;
                        return isMobile ? singleton((el_40 = Caption1, createElement(el_40, {
                            children: task.Description,
                        }))) : empty();
                    }));
                })), ["children", reactApi_1.Children.toArray(Array.from(elems_4))]));
            }))))))))))));
        }, event.Course.Tasks)));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
}

export function View(viewInputProps) {
    let elems_1, elems, el, el_2, el_4;
    const eventId = viewInputProps.eventId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        Promises_fetchEvent(eventId, dispatch, setCtx);
        Promises_fetchUserCompletedTasks(dispatch, setCtx);
        Promises_checkIsAttending(eventId, dispatch, setCtx);
    });
    const dependencies = [model_1.Event];
    reactApi.useEffect(() => {
        const matchValue = model_1.Event;
        if (matchValue != null) {
            const event = matchValue;
            Promises_checkIsEligible(event.Course.Id, dispatch, setCtx);
            if (ctx.User.IsAdmin ? true : (ctx.User.Id === event.Teacher.Id)) {
                Promises_fetchAttendees(eventId, dispatch, setCtx);
            }
        }
    }, dependencies);
    const matchValue_1 = model_1.Event;
    if (matchValue_1 != null) {
        const event_1 = matchValue_1;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 2 + "rem",
        }], (elems_1 = toList(delay(() => append_1(singleton(createElement(HeaderCard, {
            event: event_1,
            model: model_1,
            dispatch: dispatch,
        })), delay(() => {
            let matchValue_2;
            return append_1((matchValue_2 = event_1.Description, (matchValue_2 != null) ? singleton(AboutEvent(matchValue_2)) : singleton(defaultOf_1())), delay(() => singleton(createElement(TaskList, {
                event: event_1,
                model: model_1,
                dispatch: dispatch,
            }))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
    else if (model_1.IsFetchingEventDetails) {
        const el_6 = Skeleton;
        return createElement(el_6, createObj(ofArray([["style", {
            width: 100 + "%",
            display: "flex",
            flexDirection: "column",
            gap: 25 + "px ",
        }], (elems = [(el = SkeletonItem, createElement(el, {
            style: {
                height: 35 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_2 = SkeletonItem, createElement(el_2, {
            style: {
                height: 20 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        })), (el_4 = SkeletonItem, createElement(el_4, {
            style: {
                height: 20 + "vh",
            },
            animation: "wave",
            shape: "rectangle",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
    else {
        return notFoundView();
    }
}

//# sourceMappingURL=EventView.jsx.map
